import { TextField } from "@mui/material";
import React from "react";
import { NumericFormat } from "react-number-format";

const PercentInputWithBlur = ({ label, value, onChange, onBlur, ...rest }) => {
    return (
        <NumericFormat
            label={label}
            fullWidth
            customInput={TextField}
            value={value}
            onValueChange={onChange} // Recebe o valor sem o sufixo (%)
            onBlur={onBlur}
            thousandSeparator=""
            decimalSeparator="."
            suffix="%" // Adiciona o símbolo de percentual
            decimalScale={2} // Define o número de casas decimais
            fixedDecimalScale // Mantém as casas decimais fixas
            inputMode="decimal"
            inputProps={{
                inputMode: "decimal"
            }}
            {...rest}
        />
    )
}

export default PercentInputWithBlur